<template>
    <form novalidate class="md-layout" @submit.prevent="validateUser">

      <div class="md-layout-item md-elevation-0"> 

        <md-card class="md-elevation-0 m-5">

          <md-card-header class="md-layout md-alignment-center-left justify header-bg">
          Datos Personales del Partícipe
          </md-card-header>     

          <md-card-content>
            <p align="justify">
              Estimado cliente, es indispensable que la información brindada sea la correcta. Los documentos de suscripción y declaraciones juradas usarán estas respuestas. En caso de brindar información incompleta o incongruente, se congelará el proceso de suscripción y un promotor se contactará con usted para regularizar dicha información.
            </p>
            <p align="justify">
              Ante cualquier duda, comuníquese con su promotor.
            </p>  
          </md-card-content> 
        </md-card>           

        <md-card class="md-elevation-0 m-5" :class="getValidationClass('nombres')">
          <md-card-header class="md-layout md-alignment-center-left justify">
            Apellido(s) y Nombre(s) del Partícipe Titular *
          </md-card-header>
          <md-card-content>
            <p align="justify">
              Entiéndase por partícipe titular quien declarará sobre el origen de los fondos.
            </p>
            <div>            
              <md-field :class="getValidationClass('nombres')">
                <md-input 
                type="text" 
                id="nombres" 
                name="nombres" 
                placeholder="Su respuesta" 
                v-model="form.nombres" 
                v-on:keypress="isLetter($event, 0)" 
                autocomplete="off"/>
                <span class="md-error" v-if="!$v.form.nombres.required">Esta respuesta es obligatoria.</span>
                <span class="md-error" v-else-if="!$v.form.nombres.alpha">Formato inválido</span>
              </md-field>

            </div>
          </md-card-content> 
        </md-card>        

        <md-card class="md-elevation-0 m-5" :class="getValidationClass('docIdentidad')">
          <md-card-header class="md-layout md-alignment-center-left justify">
            Documento de identidad *
          </md-card-header>
          <md-card-content>
                      
              <div>
                <md-checkbox v-model="form.docIdentidad" value="DNI">DNI</md-checkbox>
                <md-checkbox v-model="form.docIdentidad" value="CE">Carné Extranjería</md-checkbox>
                <md-checkbox v-model="form.docIdentidad" value="PAS">Pasaporte</md-checkbox>
              </div>       

              <div class="radioform" :class="getValidationClass('docIdentidad')">
                <span class="md-error" v-if="!$v.form.docIdentidad.required">Esta respuesta es obligatoria.</span>
              </div>


          </md-card-content> 
        </md-card>    

        <md-card class="md-elevation-0 m-5" :class="getValidationClass('nrodocIdentidad')">
          <md-card-header class="md-layout md-alignment-center-left justify">
            Número de documento de identidad *
          </md-card-header>
          <md-card-content>

            <div>
              <md-field :class="getValidationClass('nrodocIdentidad')">
                <md-input type="text" 
                id="nrodocIdentidad" 
                name="nrodocIdentidad" 
                placeholder="Su respuesta" 
                v-model="form.nrodocIdentidad" 
                autocomplete="off"
                />
                <span class="md-error" v-if="!$v.form.nrodocIdentidad.required">Esta respuesta es obligatoria.</span>
                <span class="md-error" v-else-if="!$v.form.nrodocIdentidad.valDoc">Formato inválido</span>
                <span class="md-error" v-else-if="!$v.form.nrodocIdentidad.minLength">Formato inválido</span>
              </md-field>

            </div>
          </md-card-content> 
        </md-card> 

        <md-card v-show="isVisible" class="md-elevation-0 m-5" :class="getValidationClass('mancomunos')">
          <md-card-header  class="md-layout md-alignment-center-left justify">
            ¿Usted tiene mancomunos? *
          </md-card-header>
          <md-card-content>
            
              <div class="md-layout-item md-layout">
                <div class="md-layout-item md-medium-size-15 md-small-size-25 md-xsmall-size-30">
                  <md-checkbox v-model="form.mancomunos" value="Si" @change="ChangeOption" :disabled="isDisabled">Sí</md-checkbox>
                  <md-checkbox v-model="form.mancomunos" value="No" @change="ChangeOption" :disabled="isDisabled">No</md-checkbox>
                </div>

              </div>  

              <div class="radioform" :class="getValidationClass('mancomunos')">
                <span class="md-error" v-if="!$v.form.mancomunos.required">Esta respuesta es obligatoria.</span>
              </div>                                    

          </md-card-content>
        </md-card>

        <Botonera :form="form" :back="back" :Bottontitle="'Siguiente'" :hideBack="'true'"/>

      </div>

    </form>
</template>

<style lang="scss" scoped>
  //@import "~vue-material/theme/engine";

</style>

<script>
import { validationMixin } from 'vuelidate'
import { alpha,alpha1, alpha2, alpha3, valDoc } from '../variables'
import {
  required,
  minLength,
  requiredIf,
} from 'vuelidate/lib/validators'

const requiredIfRoot = requiredIf(function () { return this.isRequired })

export default {
  mixins: [validationMixin],
  props:{isDisabled: Boolean},
  name: 'Form1',
  data: () => ({
    form:{
    }
  }),

  mounted: function(){
    this.form = this.$store.state.form.form1
    //this.$store.dispatch("back", false);
  },
  validations(){
    var validate = {
      form: {
        nombres: {
          required,
          alpha,
          minLength: minLength(3)
        },
        docIdentidad: {
          required,
          minLength: minLength(3)
        },
        nrodocIdentidad: {
          required,
          valDoc,
          minLength: minLength(3)
        },
        mancomunos: {
          required: requiredIfRoot
        },
        mancomunosdes:{ 
          required: requiredIf(function(form,){
            return (form.mancomunos == "0")
          }),
          alpha
        } 
        
      }        
    }
    return validate;
  },
  methods: {
    back(){},
    isLetter(e, i) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      let validate;
      switch (i) {
        case 0:
          validate = alpha
          break;
        case 1:
          validate = alpha1
          break;          
        case 2:
          validate = alpha2
          break;
        case 3:
          validate = alpha3
          break;                    
      }

      if(validate(char)) return true; // Match with regex 
      else e.preventDefault(); // If not match, don't add to input text
    },
    ChangeOption(item){
      if(item != "0"){
        this.form.mancomunosdes = null;
      }
    },
    validateUser () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.isDisabledButton = true
        var index = "0"
        if(this.$route.params.token != null){
          if(this.form.mancomunos == "Si"){
            index = "21"
          }else{
            index = "4"
          } 
        }else{
          if(this.form.mancomunos == "Si"){
            index = "2"
          }else{
            index = "4"
          } 
        }
        this.$emit('setSaveForm', {id:"1", form: this.form, index: index})

      }

    },
    getValidationClass (fieldName) {
      const field = this.$v.form[fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    },
    getValidationClass2 (fieldName) {
      const field = this.$v.form[fieldName]
      const field1 = this.$v.form[fieldName+"des"]

      if (field) {

        var x = field.$invalid && field.$dirty;
        var y = field1.$invalid && field1.$dirty;

        return {
          'md-invalid': x || y
        }
      }
    }, 
     
     
  },
  computed: {
    // a computed getter
    rules: function(){
      if(this.form.docIdentidad == "DNI"){
        return "required|numeric";
      }else{
        return "required|alpha1";
      }
    },
    otros: function () {
      if(this.form.mancomunos == "0"){
        return false;
      }
      return true;
    },
    isRequired:function(){
      if(this.$route.params.token != null){
        return false
      }
      return true
    },
    isVisible:function(){
      if(this.$route.params.token != null){
        return false
      }
      return true
    }
  },
  components:{
    "Botonera": () => import('./Botonera.vue')
  }
}
</script>
